import React, { useState } from "react";
import { format } from "date-fns";
import styles from "./Card.module.css";
import { FaTicketAlt, FaHistory, FaUserTie, FaCommentAlt, FaClock, FaBarcode, FaFilePdf } from 'react-icons/fa';
import { generateMtoReport } from "../../../Components/Gesticket/HistorServiciosMto/utils/pdfGeneratorMto";
import { generateTIReport } from "../../../Components/Gesticket/HistorServicios/utils/pdfGeneratorTI";

function Card({ ticket, allticketced }) {
  const [showModal, setShowModal] = useState(false);
  const [historial, setHistorial] = useState([]);

  if (!ticket) return null;

  const getEstadoDescripcion = (estadoId) => {
    switch (estadoId) {
      case 1: return "Creado";
      case 2: return "Asignado";
      case 4: return "En proceso";
      case 5: return "Cerrado";
      case 6: return "Cancelado";
      default: return estadoId || "N/A";
    }
  };

  const getStatusClass = (estadoId) => {
    if (estadoId === 5) return styles.cerrado;
    if (estadoId === 6) return styles.cancelado;
    return "";
  };

  const formatFecha = (fecha) => {
    if (!fecha) return "N/A";
    try {
      return format(new Date(fecha), "dd/MM/yyyy HH:mm");
    } catch (e) {
      return "N/A";
    }
  };

  const handleMostrarDetalles = () => {
    const detalles = allticketced.filter(
      (t) => t.TicketId === ticket.TicketId && t.isMto === ticket.isMto
    );
    setHistorial(detalles);
    setShowModal(true);
  };

  const handleDownloadPDF = () => {
    if (ticket.EstadoId === 5) {
      if (ticket.isMto) {
        generateMtoReport(ticket);
      } else {
        generateTIReport(ticket);
      }
    }
  };

  return (
    <>
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <div className={styles.ticketBadge}>
              <FaTicketAlt />
              <span>#{ticket.TicketId || ticket.id}</span>
            </div>
            <span className={styles.areaBadge}>{ticket.area}</span>
          </div>
          <span className={`${styles.statusBadge} ${getStatusClass(ticket.EstadoId)}`}>
            {getEstadoDescripcion(ticket.EstadoId)}
          </span>
        </div>

        <div className={styles.cardBody}>
          <div className={styles.infoRow}>
            <FaClock color="#64748b" />
            <span className={styles.label}>Fecha:</span>
            <span className={styles.value}>
              {ticket.fechaCreacion ? format(new Date(ticket.fechaCreacion), "dd/MM/yyyy HH:mm") : 'N/A'}
            </span>
          </div>

          <div className={styles.infoRow}>
            <FaUserTie color="#3b82f6" />
            <span className={styles.label}>Técnico:</span>
            <span className={styles.value}>{ticket.nombreTecnico || "N/A"}</span>
          </div>

          <div className={styles.infoRow}>
            <FaBarcode color="#64748b" />
            <span className={styles.label}>Cód. Inventario:</span>
            <span className={styles.value}>{ticket.cod || "N/A"}</span>
          </div>

          <div className={styles.infoRow}>
            <FaCommentAlt color="#10b981" />
            <span className={styles.label}>Observación Original:</span>
            <p className={`${styles.value} ${styles.observacionText}`}>
              {ticket.observacionOriginal || "Sin observación"}
            </p>
          </div>
        </div>

        <div className={styles.cardFooter}>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button className={styles.detalleBtn} onClick={handleMostrarDetalles} style={{ flex: 1 }}>
              Ver Historial
            </button>
            
            {ticket.EstadoId === 5 && (
              <button 
                className={styles.detalleBtn} 
                onClick={handleDownloadPDF} 
                style={{ flex: 1, backgroundColor: '#dc2626', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}
              >
                <FaFilePdf /> PDF
              </button>
            )}
          </div>
        </div>
      </div>

      {/* MODAL PRO */}
      {showModal && (
        <div className={styles.modalOverlay} onClick={() => setShowModal(false)}>
          <div className={styles.modal} onClick={e => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3><FaHistory style={{ marginRight: '10px' }} /> Historial {ticket.area} #{ticket.TicketId}</h3>
              <button
                onClick={() => setShowModal(false)}
                style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#64748b' }}
              >&times;</button>
            </div>

            <div className={styles.modalBody}>
              <div className={styles.historialContainer}>
                {historial
                  .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
                  .map((item, idx) => (
                    <div key={item.id || idx} className={styles.historialCard}>
                      <div className={styles.histHeader}>
                        <span className={`${styles.histEstado} ${getStatusClass(item.EstadoId)}`}>
                          {getEstadoDescripcion(item.EstadoId)}
                        </span>
                        <span className={styles.histFecha}>
                          {formatFecha(item.fecha)}
                        </span>
                      </div>
                      <p className={styles.histObs}>{item.observacion}</p>
                    </div>
                  ))}
              </div>
            </div>

            <div className={styles.modalFooter}>
              <button
                className={styles.cerrarBtn}
                onClick={() => setShowModal(false)}
              >
                Cerrar Historial
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Card;
